import { LoadingButton } from '@mui/lab';
import {
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Button,
  Box,
  Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: '.5em .3em',
  color: '#000 !important',
  position: 'relative',

  [`&.${tableCellClasses.head}`]: {
    background: 'black !important',
    color: theme.palette.common.white,
    padding: '0 !important',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    margin: '0 auto',
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  padding: '0 !important',

  '&:nth-of-type(even)': {
    // padding: "15px !important",
    // background: "#F2F2F2",
    // border: '1px dotted black',
    border: 0,
  },

  // hide last border
  '&:last-child td, &:last-child th': {
    // border: 0,
  },
}));

export const StyledButton = styled(LoadingButton)(() => ({
  width: '140px',
  float: 'right',
  marginTop: '4em',
  backgroundColor: '#06623B',
  color: '#fff',
  ':hover': { background: '#06623B' },
}));

export const StyledMatchGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  minWidth: '230px',
}));

export const StyledProgressBox = styled(Box)(() => ({
  margin: '5em 0',
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledGroupBtn = styled(Button, {
  shouldForwardProp: (props) => props !== 'color',
})(({ color }) => ({
  background: color,
  color: '#fff',
  borderRadius: '5px',
  textTransform: 'capitalize',
  width: '49%',
  ':hover': { background: color, opacity: 0.7 },
}));

export const StyledScoreBox = styled(Box, {
  shouldForwardProp: (props) => props !== 'pl',
})(({ pl }) => ({
  height: '30px !important',
  width: '30px !important',
  margin: '0 auto',
  background: pl?.label,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: pl?.label != 'transparent' && '#fff',
  borderRadius: (pl?.label == '#FF0000' || pl?.label == '#FFC700') && '50%',
}));

export const useStyles = makeStyles({
  outlineInputBorder: {
    '& * > fieldset ': {
      display: 'none !important',
    },
  },
  selectBox: {
    border: '1.47px solid #C4C4C4 !important',
    borderRadius: '8px',
    margin: '3px 0px',
    padding: '2px 5px',
    fontSize: '14px !important',
    fontWeight: '700 !important',
  },
  textBoxMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#C4C4C4',
    borderRadius: '8px',
    width: '110px',
    margin: '0 auto',
  },
  numberBox: {
    backgroundColor: '#fff',
    padding: '5px',
    width: 30,
    marginRight: 'auto',
    borderRadius: '8px 0px 0px 8px',
    fontWeight: 'bold',
    border: '1px solid #C4C4C4',
  },
  outlineInput: {
    width: '25px',
    height: '25px',
    border: '1px solid #000000 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px !important',

    '& * > input ': {
      textAlign: 'center !important',
      fontSize: '13px !important',
      padding: '2.5px !important',
    },
  },

  // Table

  textBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#C4C4C4',
    borderRadius: '8px',
    minWidth: '90px !important',
    width: '100%',
    textTransform: 'capitalize',
  },

  textBoxChild: {
    width: '100%',
    margin: '0 auto',
    color: '#fff',
    fontSize: '12px !important',
    fontWeight: '700 !important',
  },
});

export const playerListStyles = makeStyles({
  box: {
    display: 'flex',
    height: '70px',
    marginTop: '8px',
    position: 'relative',
  },
  mainBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '8px',
    width: '85%',
    borderRadius: '0px 8px 8px 0px',
    color: '#fff',
    cursor: 'pointer',
  },
  blackNumBox: {
    backgroundColor: '#000',
    color: '#fff',
    width: 30,
    minWidth: 30,
    borderRadius: '8px 0px 0px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  greyBox: {
    backgroundColor: '#D3D3D3',
    zIndex: 1,
  },
  greenBox: {
    backgroundColor: '#06623B',
    zIndex: 1,
  },
  alignBoxes: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'space-around',
  },
  playerName: {
    fontWeight: 'bold !important',
    wordWrap: 'break-word',
  },
});

export const scorecardStyles = makeStyles({
  mainBox: {
    background: '#fff !important',
    minHeight: 800,
    boxShadow: '2px 4px 8px 0px #0000001A',
    boxSizing: 'border-box',
    padding: '40px',
    marginTop: '30px',
  },
  card: {
    background: '#fff !important',
    marginTop: '2rem',
    minHeight: '60%',
    boxShadow: '0px 1.7378084659576416px 57.347679138183594px 0px #6F686833',
    borderRadius: '10px',
    paddingTop: '1.5em',
  },
  boxHeading: {
    textAlign: 'center',
    marginBottom: '1em',
    fontSize: '25px !important',
    fontWeight: 'bold !important',
  },
});
